// extracted by mini-css-extract-plugin
export var loadMoreIconBrand = "sXSlB";
export var loadMoreNodeState = "BD04b";